/* Fusion Resin — video slider behaviour (drag, arrows, dots, lazy autoplay, lightbox) */
(function () {
  if (window.__frVS) return;
  window.__frVS = true;

  var lb, stage, cur = { list: [], i: 0 };

  function icon(d) { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>'; }

  function buildLB() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'fr-vs-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="fr-vs-lb__stage"></div>' +
      '<button type="button" class="fr-vs-lb__close" aria-label="Close">' + icon('<path d="M18 6 6 18M6 6l12 12"/>') + '</button>' +
      '<button type="button" class="fr-vs-lb__nav fr-vs-lb__nav--prev" aria-label="Previous">' + icon('<path d="m15 18-6-6 6-6"/>') + '</button>' +
      '<button type="button" class="fr-vs-lb__nav fr-vs-lb__nav--next" aria-label="Next">' + icon('<path d="m9 18 6-6-6-6"/>') + '</button>';
    document.body.appendChild(lb);
    stage = lb.querySelector('.fr-vs-lb__stage');
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.fr-vs-lb__close')) close();
      else if (e.target.closest('.fr-vs-lb__nav--prev')) go(-1);
      else if (e.target.closest('.fr-vs-lb__nav--next')) go(1);
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
  }

  function render() {
    var it = cur.list[cur.i]; if (!it) return;
    var d = it.dataset, html = '';
    if (d.kind === 'video') html = '<video src="' + d.src + '" poster="' + (d.poster || '') + '" autoplay loop playsinline controls></video>';
    else if (d.kind === 'embed') html = '<iframe src="' + d.src + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    else html = '<img src="' + (d.poster || d.src) + '" alt="">';
    stage.innerHTML = html;
    var v = stage.querySelector('video'); if (v) { v.muted = false; v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); }
    var multi = cur.list.length > 1;
    lb.querySelectorAll('.fr-vs-lb__nav').forEach(function (b) { b.style.display = multi ? '' : 'none'; });
  }

  function open(list, i) {
    buildLB();
    cur.list = list; cur.i = i;
    document.querySelectorAll('.fr-vs video').forEach(function (v) { v.pause(); });
    render();
    lb.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }
  function close() {
    lb.classList.remove('is-open');
    stage.innerHTML = '';
    document.body.classList.remove('overflow-hidden');
  }
  function go(dir) { cur.i = (cur.i + dir + cur.list.length) % cur.list.length; render(); }

  function init(root) {
    var track = root.querySelector('.fr-vs__track');
    var cards = [].slice.call(track.querySelectorAll('.fr-vs__card'));
    if (!cards.length) return;
    var prev = root.querySelector('[data-vs-prev]'), next = root.querySelector('[data-vs-next]'), dotsEl = root.querySelector('.fr-vs__dots');
    var dots = [];

    function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 4) / track.clientWidth)); }
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = ''; dots = [];
      var n = pages();
      root.classList.toggle('is-static', n <= 1);
      for (var k = 0; k < n; k++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'fr-vs__dot'; b.setAttribute('aria-label', 'Go to slide ' + (k + 1));
        (function (idx) { b.addEventListener('click', function () { track.scrollTo({ left: idx * track.clientWidth * 0.92, behavior: 'smooth' }); }); })(k);
        dotsEl.appendChild(b); dots.push(b);
      }
      update();
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (dots.length) {
        var idx = max > 0 ? Math.round(track.scrollLeft / max * (dots.length - 1)) : 0;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
      }
    }
    var ticking = false;
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); } }, { passive: true });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    window.addEventListener('resize', buildDots, { passive: true });
    buildDots();

    /* mouse drag */
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-dragging'); }, 0); });
    track.addEventListener('click', function (e) {
      if (moved) { moved = false; e.preventDefault(); return; }
      var card = e.target.closest('.fr-vs__card'); if (!card) return;
      var list = cards.filter(function (c) { return c.dataset.kind; });
      var i = list.indexOf(card); if (i < 0) return;
      open(list, i);
    });
    cards.forEach(function (c) {
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); } });
    });

    /* lazy autoplay of inline (muted) videos */
    var vids = track.querySelectorAll('video[data-src]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            if (!v.getAttribute('src')) { v.src = v.dataset.src; v.load(); }
            v.play().catch(function () {});
          } else { v.pause(); }
        });
      }, { root: track, threshold: 0.5, rootMargin: '0px 120px' });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(function (v) { v.src = v.dataset.src; });
    }
  }

  function boot() { document.querySelectorAll('[data-fr-vs]').forEach(function (r) { if (!r.dataset.frInit) { r.dataset.frInit = '1'; init(r); } }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
